export default "__VITE_ASSET__Oy0_mHXV__"